/* -----------------------------------------------------------------------------
 * HTTP
 *
 * @description - HTTP client configuration, based on Axios http lib
 * @documentation: https://github.com/axios/axios
 * -----------------------------------------------------------------------------
 */

import axios from 'axios'
import store from '@/store'

const http = axios.create({
  baseURL: '/api/v2/'
})

// Http request interceptor
http.interceptors.request.use(cfg => {
  cfg.headers.CSRF = store.getters['moduleSecurity/getCSRFToken']
  cfg.headers['Ariadne-Exchange-Mode'] = store.getters['moduleUser/getPortfolioData'].mode
  if (!('noToken' in cfg)) cfg.headers.Authorization = store.getters['moduleSecurity/getToken']
  store.commit('moduleWizard/SET_NAV_FIELD', { f: 'loadingNext', v: true })
  return cfg
}, err => {
  return Promise.reject(err)
})

// Http response interceptor
http.interceptors.response.use(res => {
  store.commit('moduleWizard/SET_NAV_FIELD', { f: 'loadingNext', v: false })
  return res
}, err => {
  store.commit('moduleWizard/SET_NAV_FIELD', { f: 'loadingNext', v: false })
  return Promise.reject(err)
})

export { http }
